import { SubscriptionGuard } from './guards/subscriptions/subscriptions.guard';
import { BookingGuard } from './guards/booking/booking.guard';
import { TourGuard } from './guards/tour.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RouterGuard } from './guards/router/router.guard';
import { HistoryGuard } from './guards/history/history.guard';
import { MenuGuard } from './guards/menu/menu.guard';
import { LoginGuard } from './guards/user/login.guard';
import { ChargerGuard } from './guards/charger/charger.guard';
import { WensGuard } from './guards/wens/wens.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages/starting/starting.module').then(m => m.StartingPageModule),
  },
  // {
  //   path: '',
  //   redirectTo: 'waiting',
  //   pathMatch: 'full'
  // },
  {
    path: 'vehicles',
    loadChildren: () => import('./pages/vehicles/vehicles.module').then( m => m.VehiclesPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuPageModule),
    canActivate: [MenuGuard]
  },
  {
    path: 'personal-data-add',
    loadChildren: () => import('./pages/personal-data-add/personal-data-add.module').then( m => m.PersonalDataAddPageModule)
  },
  {
    path: 'vehicle-data',
    loadChildren: () => import('./pages/vehicle-data/vehicle-data.module').then( m => m.VehicleDataPageModule)
  },
  {
    path: 'vehicle-data-detail',
    loadChildren: () => import('./pages/vehicle-data-detail/vehicle-data-detail.module').then( m => m.VehicleDataDetailPageModule)
  },
  {
    path: 'filter',
    loadChildren: () => import('./pages/filter/filter.module').then( m => m.FilterPageModule)
  },
  {
    path: 'pay-cards',
    loadChildren: () => import('./pages/pay-cards/pay-cards.module').then( m => m.PayCardsPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'personal-data-sum',
    loadChildren: () => import('./pages/personal-data-sum/personal-data-sum.module').then( m => m.PersonalDataSumPageModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'personal-data-edit',
    loadChildren: () => import('./pages/personal-data-edit/personal-data-edit.module').then( m => m.PersonalDataEditPageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then( m => m.HistoryPageModule),
    canActivate: [LoginGuard, HistoryGuard]
  },
  {
    path: 'permission-info',
    loadChildren: () => import('./pages/permission-info/permission-info.module').then( m => m.PermissionInfoPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'legal',
    loadChildren: () => import('./pages/legal/legal.module').then( m => m.LegalPageModule)
  },
  {
    path: 'tour',
    loadChildren: () => import('./pages/tour/tour.module').then( m => m.TourPageModule)
  },
  {
    path: 'charge-meters',
    loadChildren: () => import('./pages/charge-meters/charge-meters.module').then( m => m.ChargeMetersPageModule)
  },
  {
    path: 'charge-sum',
    loadChildren: () => import('./pages/charge-sum/charge-sum.module').then( m => m.ChargeSumPageModule)
  },
  {
    path: 'router',
    loadChildren: () => import('./pages/router/router.module').then( m => m.RouterPageModule),
    canActivate: [LoginGuard, RouterGuard]
  },
  {
    path: 'waiting',
    loadChildren: () => import('./pages/waiting/waiting.module').then( m => m.WaitingPageModule),
  },
  // {
  //   path: 'home',
  //   loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  // },
  {
    path: 'history-detail',
    loadChildren: () => import('./pages/history-detail/history-detail.module').then( m => m.HistoryDetailPageModule)
  },
  {
    path: 'charge-select',
    loadChildren: () => import('./pages/charge-select/charge-select.module').then( m => m.ChargeSelectPageModule),
  },
  {
    path: 'charge-config',
    loadChildren: () => import('./pages/charge-config/charge-config.module').then( m => m.ChargeConfigPageModule)
  },
  {
    path: 'charge-start',
    loadChildren: () => import('./pages/charge-start/charge-start.module').then( m => m.ChargeStartPageModule)
  },
  {
    path: 'wenea-home',
    loadChildren: () => import('./pages/wenea-home/wenea-home.module').then( m => m.WeneaHomePageModule)
  },
  {
    path: 'legend',
    loadChildren: () => import('./pages/legend/legend.module').then( m => m.LegendPageModule)
  },
  {
    path: 'feedback',
    loadChildren: () => import('./pages/feedback/feedback.module').then( m => m.FeedbackPageModule)
  },
  {
    path: 'router-tour',
    loadChildren: () => import('./pages/router-tour/router-tour.module').then( m => m.RouterTourPageModule)
  },
  {
    path: 'charge-successful',
    loadChildren: () => import('./pages/charge-successful/charge-successful.module').then( m => m.ChargeSuccessfulPageModule)
  },
  // {
  //   path: 'wens',
  //   loadChildren: () => import('./pages/wens/wens.module').then( m => m.WensPageModule),
  //   canActivate: [WensGuard]
  // },
  // {
  //   path: 'subscriptions',
  //   loadChildren: () => import('./pages/subscriptions/subscriptions.module').then( m => m.SubscriptionsPageModule),
  //   canActivate: [SubscriptionGuard]
  // },
  // {
  //   path: 'subscription-detail',
  //   loadChildren: () => import('./pages/subscription-detail/subscription-detail.module').then( m => m.SubscriptionDetailPageModule)
  // },
  // {
  //   path: 'wens-tour',
  //   loadChildren: () => import('./pages/wens-tour/wens-tour.module').then( m => m.WensTourPageModule)
  // },
  // {
  //   path: 'wens',
  //   loadChildren: () => import('./pages/wens/wens.module').then( m => m.WensPageModule),
  //   canActivate: [WensGuard]
  // },
  // {
  //   path: 'subscriptions',
  //   loadChildren: () => import('./pages/subscriptions/subscriptions.module').then( m => m.SubscriptionsPageModule),
  //   canActivate: [SubscriptionGuard]
  // },
  // {
  //   path: 'subscription-detail',
  //   loadChildren: () => import('./pages/subscription-detail/subscription-detail.module').then( m => m.SubscriptionDetailPageModule)
  // },
  // {
  //   path: 'wens-tour',
  //   loadChildren: () => import('./pages/wens-tour/wens-tour.module').then( m => m.WensTourPageModule)
  // },
  // {
  //   path: 'booking-form',
  //   loadChildren: () => import('./pages/booking-form/booking-form.module').then( m => m.BookingFormPageModule),
  //   canActivate: [BookingGuard]
  // },
  // {
  //   path: 'booking-resume',
  //   loadChildren: () => import('./pages/booking-resume/booking-resume.module').then( m => m.BookingResumePageModule)
  // },
  // {
  //   path: 'booking-tour',
  //   loadChildren: () => import('./pages/booking-tour/booking-tour.module').then( m => m.BookingTourPageModule)
  // },
   {
    path: 'anon-charge-start',
    loadChildren: () => import('./pages/anon-charge-start/anon-charge-start.module').then( m => m.AnonChargeStartPageModule)
  },
  // {
  //   path: 'subscriptions-tour',
  //   loadChildren: () => import('./pages/subscriptions-tour/subscriptions-tour.module').then( m => m.SubscriptionsTourPageModule)  
  // },
  // {
  //   path: 'wens-history',
  //   loadChildren: () => import('./pages/wens-history/wens-history.module').then( m => m.WensHistoryPageModule)
  // },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule)
  },
  {
    path: 'starting',
    loadChildren: () => import('./pages/starting/starting.module').then( m => m.StartingPageModule)
  },
  {
    path: 'charge-failed',
    loadChildren: () => import('./pages/charge-failed/charge-failed.module').then( m => m.ChargeFailedPageModule)
  },

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
